export const API_KEY = process.env.API_KEY;
export const API_URL =
  "https://api.openweathermap.org/data/3.0/onecall?lat=40.5581&lon=-90.0351&units=imperial&appid=";
